export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_11.0e602503.jpg";